export const Lotties = {
  emptyCartLottie: require("../assets/lottie/emptyCart.json"),
  redCross: require("../assets/lottie/Red_cross.json"),
  okLoader: require("../assets/lottie/loader.json"),
};
